import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=6b10284c&scoped=true&"
import script from "./contract.vue?vue&type=script&lang=js&"
export * from "./contract.vue?vue&type=script&lang=js&"
import style0 from "./contract.vue?vue&type=style&index=0&id=6b10284c&prod&scoped=true&lang=css&"
import style1 from "./contract.vue?vue&type=style&index=1&id=6b10284c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b10284c",
  null
  
)

export default component.exports